import Loader from "@/atoms-react/loader/Loader.react";
import { useOrigin } from "@/features/flow/hooks/use-origin";
import { FromURL } from "@/features/flow/types";
import { Routes } from "@/features/router";
import { useSecurity } from "@/features/security/hooks/use-react-security";
import { useUser } from "@/features/user/hooks/use-user";
import { Navigate, Outlet, useSearchParams } from "react-router-dom";

export const PrivateForceWebauthnRoutes = () => {
  const origin = useOrigin();
  if (origin === FromURL.None) return <Outlet />;
  const { useUserProfile } = useUser();
  const { data: user } = useUserProfile();
  const { getIsWebAuthnActivated } = useSecurity();
  const forceWebauthn = user?.identityPartners?.find(
    (idp) => idp?.name?.toLocaleLowerCase() === sessionStorage.getItem("origin")
  )?.force_webauthn;
  if (!forceWebauthn) return <Outlet />;
  const [searchParams] = useSearchParams();
  const redirectToLvl = searchParams.get("level_to_complete");
  const webauthnRoute = !redirectToLvl
    ? Routes.force_webauthn
    : `${Routes.force_webauthn}?level_to_complete=${redirectToLvl}`;

  const { data: isWebAuthnActive, isPending } = getIsWebAuthnActivated({
    enabled: !!forceWebauthn,
    queryKey: ["security", "isWebAuthnActivated"]
  });

  if (isPending)
    return (
      <div className="flex flex-row justify-center">
        <div className="flex h-full grow flex-col items-center justify-center">
          <Loader />
        </div>
      </div>
    );

  if (isWebAuthnActive) {
    sessionStorage.removeItem("force_webauthn");
    return <Outlet />;
  } else {
    const cachedWebauth = sessionStorage.getItem("force_webauthn")
      ? (JSON.parse(sessionStorage.getItem("force_webauthn") as string) as boolean)
      : false;
    if (!cachedWebauth && forceWebauthn) sessionStorage.setItem("force_webauthn", "true");
    return forceWebauthn ? <Navigate to={webauthnRoute} replace /> : <Outlet />;
  }
};
